<template>
  <div style="margin: 20px 15px 20px 15px; padding: 30px 25px 30px 25px; background-color: white">
    <el-form :inline="true">
      <el-form-item label="日期">
        <el-date-picker
            v-model="dateRange"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="对冲产品:">
        <el-select v-model="hedgeProductType" placeholder="请选择对冲产品">
          <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对冲目标类型:">
        <el-select v-model="hedgeTargetType" placeholder="请选择对冲目标类型">
          <el-option v-if="hedgeProductType==='SPOT'" v-for="item in hedgeTargetTypeEnum_SPOT" :key="item.key" :label="item.label" :value="item.key"></el-option>
          <el-option v-if="hedgeProductType==='SUPER_CONTRACT'" v-for="item in hedgeTargetTypeEnum_SUPER_CONTRACT" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对冲动作类型:">
        <el-select v-model="hedgeActionType" placeholder="请选择对冲产品">
          <el-option v-for="item in hedgeActionTypeEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对冲目标值:">
        <el-input v-model="hedgeTargetValue" placeholder="请输入对冲目标值"></el-input>
      </el-form-item>
      <el-form-item label="对冲状态:">
        <el-popover placement="left" width="600" trigger="click">
            <el-checkbox-group v-model="statusCodeList">
              <el-checkbox v-for="item in statusCodeEnum" :label="item.key" name="type"></el-checkbox>
            </el-checkbox-group>
          <el-button slot="reference">选择</el-button>
        </el-popover>
      </el-form-item>
      <el-form-item label="是否统计：">
        <el-select v-model="joinProfitLoss" placeholder="请选择">
          <el-option key="" label="" value=""></el-option>
          <el-option key="是" label="是" value="true"></el-option>
          <el-option key="否" label="否" value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryBatchRecords">查询</el-button>
      </el-form-item>
    </el-form>

    <el-row><el-col :span="24"><div class="grid-content bg-purple-light"></div></el-col></el-row>
    <br><br>

    <el-form  :inline="true">
      <el-form-item label="合并订单ID:">
        <el-input v-model="batchOrderId" placeholder="请输入ID查询" style="width: 400px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryBatchRecordsById">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="top" v-if="isShow">
      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column fixed prop="id" label="ID" sortable width="130"></el-table-column>
        <el-table-column prop="" label="交易对" sortable width="120">
          <template slot-scope="scope">
<!--            <el-input :value="scope.row.pair"  @change="updateValue(scope.row,'pair', $event)" v-if="scope.row.hedgeActionType==='MANUAL'"></el-input>-->
            <span>{{ scope.row.pair }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="clientOrderId" label="CLIENT订单ID" sortable width="130"></el-table-column>
        <el-table-column prop="" label="已成交额" sortable width="120">
          <template slot-scope="scope">
<!--            <el-input :value="scope.row.dealQuoteAmount"  @change="updateValue(scope.row,'dealQuoteAmount', $event)" v-if="scope.row.hedgeActionType==='MANUAL'"></el-input>-->
            <span>{{ scope.row.dealQuoteAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="已成交量" sortable width="120">
          <template slot-scope="scope">
<!--            <el-input :value="scope.row.dealBaseAmount"  @change="updateValue(scope.row,'dealBaseAmount', $event)" v-if="scope.row.hedgeActionType==='MANUAL'"></el-input>-->
            <span>{{ scope.row.dealBaseAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="planHedgeAmount" label="委托数量" sortable width="80"></el-table-column>
        <el-table-column prop="planHedgePrice" label="委托价格" sortable width="80"></el-table-column>
        <el-table-column prop="financeDifference" label="财务差额" sortable width="80"></el-table-column>
        <el-table-column prop="externalOrderDirection" label="外部委托方向" sortable width="100">
          <template slot-scope="scope">
<!--            <el-select :value="scope.row.externalOrderDirection"  @change="updateValue(scope.row,'externalOrderDirection',$event)" v-if="scope.row.hedgeActionType==='MANUAL'">-->
<!--              <el-option v-for="item in externalOrderDirectionOptions" :key="item.key" :label="item.key" :value="item.key"></el-option>-->
<!--            </el-select>-->
            <span>{{ scope.row.externalOrderDirection }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="externalOrderStatus" label="对冲状态" sortable width="80"></el-table-column>
        <el-table-column prop="externalOrderId" label="外部订单ID" sortable width="150">
          <template slot-scope="scope">
<!--            <el-input :value="scope.row.externalOrderId"  @change="updateValue(scope.row,'externalOrderId', $event)" v-if="scope.row.hedgeActionType==='MANUAL'"></el-input>-->
            <span>{{ scope.row.externalOrderId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="failType" label="失败原因" sortable width="120"></el-table-column>
        <el-table-column prop="hedgeActionType" label="对冲动作类型" sortable width="80"></el-table-column>
        <el-table-column prop="" label="对冲产品类型" sortable width="120">
          <template slot-scope="scope">
<!--            <el-select :value="scope.row.hedgeProductType"  @change="updateValue(scope.row,'hedgeProductType', $event)" v-if="scope.row.hedgeActionType==='MANUAL'">-->
<!--              <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.key" :value="item.key"></el-option>-->
<!--            </el-select>-->
            <span>{{ scope.row.hedgeProductType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="对冲目标类型" sortable width="120">
          <template slot-scope="scope">
<!--            <el-select :value="scope.row.hedgeTargetType"  @change="updateValue(scope.row,'hedgeTargetType', $event)" v-if="scope.row.hedgeActionType==='MANUAL'">-->
<!--              <el-option v-for="item in hedgeTargetTypeEnum_SPOT" :key="item.key" :label="item.key" :value="item.key" v-if="scope.row.hedgeProductType==='SPOT'"></el-option>-->
<!--              <el-option v-for="item in hedgeTargetTypeEnum_SUPER_CONTRACT" :key="item.key" :label="item.key" :value="item.key" v-if="scope.row.hedgeProductType==='SUPER_CONTRACT'"></el-option>-->
<!--            </el-select>-->
            <span>{{ scope.row.hedgeTargetType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="hedgeTargetValue" label="对冲目标值"  sortable width="120">
          <template slot-scope="scope">
<!--            <el-input :value="scope.row.hedgeTargetValue"  @change="updateValue(scope.row,'hedgeTargetValue', $event)" v-if="scope.row.hedgeActionType==='MANUAL'"></el-input>-->
            <span>{{ scope.row.hedgeTargetValue }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="对冲账号" sortable width="160">
          <template slot-scope="scope">
            <el-select :value="scope.row.hedgeTargetExchange"  @change="updateValue(scope.row,'hedgeTargetExchange', $event)" v-if="scope.row.hedgeActionType==='MANUAL'">
              <el-option v-for="item in hedgeAccountEnum" :key="item.key" :label="item.key" :value="item.key"></el-option>
            </el-select>
            <span v-else>{{ scope.row.hedgeTargetExchange }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="joinProfitLoss" label="是否统计" width="80">
          <template slot-scope="scope">
<!--            <el-select :value="scope.row.joinProfitLoss"  @change="updateValue(scope.row,'joinProfitLoss', $event)" v-if="scope.row.hedgeActionType==='MANUAL'">-->
<!--              <el-option v-for="item in joinProfitLossOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>-->
<!--            </el-select>-->
            <span>{{ scope.row.joinProfitLoss }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="startHedgeTime" label="开始对冲时间" sortable width="90"></el-table-column>
        <el-table-column prop="exchangeTime" label="交易所时间" sortable width="90"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" sortable width="90"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" sortable width="90"></el-table-column>
        <el-table-column prop="remark" label="备注" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="remove(scope.row)" type="danger" size="small" v-if="scope.row.hedgeActionType==='MANUAL'">删除</el-button>
            <el-button @click="update(scope.row)" type="success" size="small" v-if="scope.row.hedgeActionType==='MANUAL'">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background
                     layout="total, sizes, prev, pager, next, jumper"
                     :page-size="pageSize"
                     :page-sizes="[1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                     :total="total"
                     :current-page="currentPageNum"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange">
      </el-pagination>
      <div style="text-align:right">
        <el-button type="success" plain @click="exportExcel()">全量导出excel</el-button>
        <el-button type="success" plain @click="exportCurrentData2Excel()">当前页导出excel</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import './store'
import utils from './utils';
import '@/entries/Machine/cache'
import axios from 'axios'
import api from "@/entries/HedgeCenter/MarketSheet/hedgeApi";
import {mapActions, mapState} from "vuex";

const hedgeActionTypeOptions = [{key:'', label:''}, {key:'AUTO', label:'自动'}, {key:'MANUAL', label:'人工'}]
const hedgeTargetTypeEnum_SPOT_Op = [
  {key:'', label:''},
  {key:'SPOT_PAIR_COMMON', label:'现货匹配交易对'},
  {key:'SPOT_PAIR_API', label:'现货只匹配交易对的API的部分，优先级SPOT'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const hedgeTargetTypeEnum_SUPER_CONTRACT_Op = [
  {key:'', label:''},
  {key:'SC_PAIR', label:'超级合约的交易对'},
  {key:'SC_USER_ID', label:'超级合约的交易对用户ID'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const statusCodeOptions = [
  {key:'NEW', label:'刚刚创建'},
  {key:'PARTIALLY_FILLED', label:'部分成交'},
  {key:'FILLED', label:'已经成交完成'},
  {key:'CANCELED', label:'已取消'},
  {key:'CREATE_FAILED', label:'创建失败'}
]
const externalOrderDirectionOptions = [{key:'BID', label:'买'}, {key:'ASK', label:'卖'}]
const joinProfitLossOptions = [{key:true, label:'是'}, {key:false, label:'否'}]
const columns = [
  {title:'ID',key:'id'},
  {title:'交易对',key:'pair'},
  {title:'CLIENT订单ID',key:'clientOrderId'},
  {title:'已成交额',key:'dealQuoteAmount'},
  {title:'已成交量',key:'dealBaseAmount'},
  {title:'委托数量',key:'planHedgeAmount'},
  {title:'委托价格',key:'planHedgePrice'},
  {title:'外部委托方向',key:'externalOrderDirection'},
  {title: '对冲状态', key:'externalOrderStatus'},
  {title:'外部订单ID',key:'externalOrderId'},
  {title:'失败原因',key:'failType'},
  {title:'对冲动作类型',key:'hedgeActionType'},
  {title:'对冲产品类型',key:'hedgeProductType'},
  {title:'对冲目标类型',key:'hedgeTargetType'},
  {title:'对冲目标类型',key:'hedgeTargetValue'},
  {title:'对冲账号',key:'hedgeTargetExchange'},
  {title:'是否统计',key:'joinProfitLoss'},
  {title:'财务差额',key:'financeDifference'},
  {title:'开始对冲时间',key:'startHedgeTime'},
  {title:'交易所时间',key:'exchangeTime'},
  {title:'创建时间',key:'createdTime'},
  {title:'更新时间',key:'updateTime'},
  {title:'备注',key:'remark'},
]


export default {
  name: "BatchRecords",
  data() {
    return {
      pages:0,
      total:'',
      loading:false,
      batchOrderId:'',
      currentPageNum:1,
      pageSize:20,
      isShow:false,
      dateRange:'',
      tableData:[],
      hedgeProductType:'',
      hedgeTargetType:'',
      hedgeTargetValue:'',
      hedgeActionType:'',
      statusCodeList:[],
      buffer:'',
      hedgeActionTypeEnum:hedgeActionTypeOptions,
      externalOrderDirectionOptions:externalOrderDirectionOptions,
      joinProfitLossOptions:joinProfitLossOptions,
      hedgeTargetTypeEnum_SPOT:hedgeTargetTypeEnum_SPOT_Op,
      hedgeTargetTypeEnum_SUPER_CONTRACT:hedgeTargetTypeEnum_SUPER_CONTRACT_Op,
      statusCodeEnum:statusCodeOptions,
      columns:columns,
      joinProfitLoss:'',
      financeDifference:'',
    }
  },
  computed: {
    ...mapState('newHedgeStore', ['hedgeAccountEnum', 'hedgeProductTypeOptions', 'pickerOptions']),
    params() {
      return {
        startTime:new Date(this.dateRange[0]).getTime(),
        endTime:new Date(this.dateRange[1]).getTime(),
        hedgeProductType:this.hedgeProductType,
        hedgeTargetType:this.hedgeTargetType,
        hedgeTargetValue:this.hedgeTargetValue,
        hedgeActionType:this.hedgeActionType,
        statusCodeList:this.statusCodeList.join(','),
        joinProfitLoss:this.joinProfitLoss,
        pageNum:this.currentPageNum,
        pageSize:this.pageSize
      };
    },
    paramsBak() {
      return {
        dateRange:this.dateRange,
        hedgeProductType:this.hedgeProductType,
        hedgeTargetType:this.hedgeTargetType,
        hedgeTargetValue:this.hedgeTargetValue,
        hedgeActionType:this.hedgeActionType,
        statusCodeList:this.statusCodeList.join(','),
        joinProfitLoss:this.joinProfitLoss,
      };
    },
  },
  created() {
    this.hedgeProductType = this.hedgeProductTypeOptions[0].key;
  },
  methods: {
    update(data) {
      data.joinProfitLoss = data.joinProfitLoss === '是'
      utils.updateManualHedgeRecord(data).then((response)=>{
        if (response.data === true){
          this.$message.success("修改成功");
          this.queryBatchRecords()
        } else {
          this.$message.error("修改失败");
        }
      })
    },
    updateValue(data, name, val){
      data[name] = val
    },
    remove(data) {
      this.$confirm('此操作将永久删除该, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        utils.removeManualBatchRecord(data).then((response)=>{
          if (response.data === true){
            this.dialogVisible = false;
            this.$message.success('删除成功');
            this.queryBatchRecords()
          }else{
            this.$message.error('删除失败')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    queryBatchRecords(){
      if (!this.dateRange){
        this.$message({showClose: true, message: '请选择日期', type: 'error'})
        return
      }
      if (new Date(this.dateRange[0]).getTime() > new Date().getTime()){
        this.$message({showClose: true, message: '时间选择错误，起止时间不合理', type: 'error'});
        return
      }

      if (this.buffer === ''){
        this.buffer = this.paramsBak
      } else {
        if (this.paramsBak !== this.buffer){
          this.params.pageNum = 1
          this.buffer = this.paramsBak
        }
      }
      utils.queryStrategyBatchRecords(this.params).then((response)=>{
        this.isShow = true
        this.total = response.data.total
        this.pages = response.data.pages
        this.pageSize = response.data.size
        this.currentPageNum = response.data.current
        let tableData = response.data.records
        for (let key in tableData){
          tableData[key].startHedgeTime = utils.getLocalTime(tableData[key].startHedgeTime)
          tableData[key].updateTime = utils.getLocalTime(tableData[key].updateTime)
          tableData[key].createdTime = utils.getLocalTime(tableData[key].createdTime)
          tableData[key].exchangeTime = utils.getLocalTime(tableData[key].exchangeTime)
          tableData[key].joinProfitLoss = tableData[key].joinProfitLoss === true ? '是':'否';
        }
        this.tableData = tableData
      })
    },
    handleSizeChange(val){
      this.params.pageSize = val
      this.queryBatchRecords()
    },
    handleCurrentChange(val) {
      this.params.pageNum = val
      this.queryBatchRecords()
    },
    queryBatchRecordsById(){
      const data = {"batchOrderId":this.batchOrderId}
      utils.queryBatchRecordsById(data).then((response)=>{
        let tableData = [response.data]
        for (let key in tableData){
          tableData[key].startHedgeTime = utils.getLocalTime(tableData[key].startHedgeTime)
          tableData[key].updateTime = utils.getLocalTime(tableData[key].updateTime)
          tableData[key].createdTime = utils.getLocalTime(tableData[key].createdTime)
          tableData[key].exchangeTime = utils.getLocalTime(tableData[key].exchangeTime)
        }
        this.isShow = true
        this.tableData = tableData
        this.total = 1
        this.currentPageNum = 1
      })
    },

    exportExcel(){
      this.loading = true
      utils.queryAllStrategyBatchRecords(this.params).then((response)=>{
        let records = response.data
        for (let key in records){
          records[key].startHedgeTime = utils.getLocalTime(records[key].startHedgeTime)
          records[key].updateTime = utils.getLocalTime(records[key].updateTime)
          records[key].createdTime = utils.getLocalTime(records[key].createdTime)
          records[key].exchangeTime = utils.getLocalTime(records[key].exchangeTime)
          records[key].joinProfitLoss = records[key].joinProfitLoss === true ? '是':'否';
        }
        let startTime = utils.getLocalTime(this.dateRange[0])
        let endTime = utils.getLocalTime(this.dateRange[1])
        let title = '合并对冲记录报表' + startTime + '-' + endTime
        utils.export2Excel(this.columns, records, title)
        this.loading = false
      })
    },

    exportCurrentData2Excel(){
      let title = '合并对冲记录报表'
      let records = this.tableData
      for (let key in records){
        records[key].startHedgeTime = utils.getLocalTime(records[key].startHedgeTime)
        records[key].updateTime = utils.getLocalTime(records[key].updateTime)
        records[key].createdTime = utils.getLocalTime(records[key].createdTime)
        records[key].exchangeTime = utils.getLocalTime(records[key].exchangeTime)
      }
      utils.export2Excel(this.columns, records, title)
    },
  },
}

</script>

<style scoped>
.block{
  background-color: white;
  margin: 10px 15px 10px 15px;
  padding: 10px 5px 10px 5px;
  height: auto;
}
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>
